export const moduleId = 'settlementTask';

export const state = {
    lists:{},
    feeIsShow: false,//详情显示隐藏
    dialogzt: false,//账套显示隐藏
    flag: false,//是否可编辑
    orgId: '',
    isShow: true,
    id: '',
    isRouter:false,
    isAdd: true,
    abId: '',
}
export const mutations = {
    setFeeIsShow(state, data) {
        state.feeIsShow = data
    },
    setDialogzt(state, data) {
        state.dialogzt = data
    },
    setOrgList(state, data) {
        state.lists = data
    },
    setFalg(state, data) {
        state.flag = data
    },
    setIsRouter(state,data){
        state.isRouter = data
    }
}
export const actions = {}


// WEBPACK FOOTER //
// ./src/store/modules/settlement-center/settlement-task/index.js